import React, { MouseEventHandler, ReactElement } from 'react'

function ButtonFullWidth(
    props: Readonly<{
      children: ReactElement | string;
      onClick: MouseEventHandler<HTMLButtonElement>;
    }>
  ) {
    return (
      <button
        className={
          "w-full  text-left rounded-md pl-[20px] pt-[4px] pb-[4px] md:pt-[8px] md:pb-[8px] hover:bg-lightbg-150"
        }
        onClick={props.onClick}
      >
        {props.children}
      </button>
    );
  }
  

export default ButtonFullWidth

